// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13mHD","col":"styles_col__3QShD","actions":"styles_actions__2t_n0","conflict":"styles_conflict__2xgf_"};